import PropTypes from 'prop-types';
import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { daysBetween } from '../../../core/date';

function calculate(bid, nights) {
  let sum = 0;
  if (bid.bidset.suites) {
    sum += Number(bid.suite_rate || 0) * bid.bidset.suites * nights;
  }
  if (bid.bidset.kings) {
    sum += Number(bid.king_rate || 0) * bid.bidset.kings * nights;
  }
  if (bid.bidset.queens) {
    sum += Number(bid.queen_rate || 0) * bid.bidset.queens * nights;
  }
  return sum;
}

function calculateTax(subTotal, taxRate) {
  if (taxRate) {
    return Number(taxRate || 0) * subTotal;
  }
  return 0;
}

const formatMoney = (value, currency) => {
  if (!value) return value;
  // const onlyNums = value.replace(/[^\d]/g, '');
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    minimumFractionDigits: 2,
    currency,
  });
  return formatter.format(value);
};

class BidDetailTable extends React.Component {
  render() {
    const { bid } = this.props;
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 1,
    });

    const currency = this.props.bid.hotel.currency;
    const taxRate = formatter.format(this.props.bid.hotel.tax_rate);
    const commissionRate = formatter.format(this.props.bid.commission_rate);
    const nights = daysBetween(bid.bidset.event.end, bid.bidset.event.start);

    const subTotal = calculate(this.props.bid, nights);
    const tax = calculateTax(subTotal, this.props.bid.hotel.tax_rate);
    const totalRate = subTotal + tax;

    const showCommission = !this.props.isTourManager;

    return (
      <div
        className="row"
        style={{
          paddingTop: '20px',
          paddingBottom: '20px',
        }}
      >
        <div className="col-md-12">
          {this.props.canEdit && <Button onClick={this.props.handleEdit}>Edit</Button>}
          <p>Currency: {currency}</p>
          <Table striped bordered condensed hover className="hotel-bid-table">
            <thead>
              <tr>
                <td>
                  <strong>Room Type</strong>
                </td>
                <td style={{ padding: '10px 10px 10px 5px' }}>
                  <strong>Number of Rooms</strong>
                </td>
                <td>
                  <strong>Rate Per Night</strong>
                </td>
              </tr>
            </thead>
            <tbody>
              {bid.bidset.suites !== 0 && (
                <tr>
                  <td>Suite</td>
                  <td style={{ padding: '10px 10px 10px 5px' }}>{bid.bidset.suites}</td>
                  <td style={{ textAlign: 'right' }}>{formatMoney(bid.suite_rate, currency)}</td>
                </tr>
              )}
              {bid.bidset.kings !== 0 && (
                <tr>
                  <td>King</td>
                  <td style={{ padding: '10px 10px 10px 5px' }}>{bid.bidset.kings}</td>
                  <td style={{ textAlign: 'right' }}>{formatMoney(bid.king_rate, currency)}</td>
                </tr>
              )}
              {bid.bidset.queens !== 0 && (
                <tr>
                  <td>Double Room</td>
                  <td style={{ padding: '10px 10px 10px 5px' }}>{bid.bidset.queens}</td>
                  <td style={{ textAlign: 'right' }}>{formatMoney(bid.queen_rate, currency)}</td>
                </tr>
              )}
              {totalRate !== 0 && (
                <tr>
                  <td colSpan={2} style={{ padding: '10px 10px 10px 5px' }}>
                    Subtotal (excluding taxes)
                  </td>
                  <td style={{ textAlign: 'right' }}>{formatMoney(subTotal, currency)}</td>
                </tr>
              )}
              {totalRate !== 0 && (
                <tr>
                  <td colSpan={2} style={{ padding: '10px 10px 10px 5px' }}>
                    Taxes (rate {taxRate})
                  </td>
                  <td style={{ textAlign: 'right' }}>{formatMoney(tax, currency)}</td>
                </tr>
              )}
              {totalRate !== 0 && (
                <tr>
                  <td colSpan={2} style={{ padding: '10px 10px 10px 5px' }}>
                    Total
                  </td>
                  <td style={{ textAlign: 'right' }}>{formatMoney(totalRate, currency)}</td>
                </tr>
              )}
            </tbody>
          </Table>

          {showCommission && <p>Commission: {commissionRate}</p>}
        </div>
      </div>
    );
  }
}

BidDetailTable.propTypes = {
  bid: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  handleEdit: PropTypes.func.isRequired,
};

export default BidDetailTable;



// WEBPACK FOOTER //
// src/routes/tours/components/BidDetailTable.js